var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgW21LocateOrangeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.296a8.296 8.296 0 1 0 0-16.592 8.296 8.296 0 0 0 0 16.592z",
    stroke: "#FF7035",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 2.518v1.334h2.667V2.518h-2.667zm2.667-1.185a1.333 1.333 0 0 0-2.667 0h2.667zm0 1.185V1.333h-2.667v1.185h2.667zM10.666 22.667a1.333 1.333 0 0 0 2.667 0h-2.667zm2.667-1.186v-1.333h-2.667v1.333h2.667zm0 1.186V21.48h-2.667v1.186h2.667zM21.481 10.667h-1.333v2.666h1.333v-2.666zm1.185 2.666a1.333 1.333 0 0 0 0-2.666v2.666zm-1.185 0h1.185v-2.666h-1.185v2.666zM1.333 10.667a1.333 1.333 0 0 0 0 2.666v-2.666zm1.185 2.666h1.334v-2.666H2.518v2.666zm-1.185 0h1.185v-2.666H1.333v2.666zM12 14.37a2.37 2.37 0 1 0 0-4.74 2.37 2.37 0 0 0 0 4.74z",
    fill: "#FF7035",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW21LocateOrangeIcon);
export default __webpack_public_path__ + "static/media/w21-locate-orange-icon.f6675cad64e7237428c7e5a130a506ae.svg";
export { ForwardRef as ReactComponent };